module.exports = __webpack_public_path__ + "img/logo-jolahr-small.808942a1.svg";